import client from "libs/HttpClient";

/**
 * Service class for handling payment.
 */
class PaymentService {
  /**
   * Adds a new Payment based on the provided request.
   *
   * @param request - The request parameters for adding a payment.
   * @returns A Promise that resolves to the Axios response for the add payment request.
   */
  static storePayment(request: any) {
    return client.post("admin/payment/create", request);
  }

  /**
   * Verify Payment based on the provided request.
   *
   * @param request - The request parameters for verifying a payment.
   * @returns A Promise that resolves to the Axios response for the verify payment request.
   */
  static verifyPayment(request: any) {
    return client.post("admin/payment/verify", request);
  }

  /**
   * Verify Payment based on the provided request.
   *
   * @param request - The request parameters for verifying a payment.
   * @returns A Promise that resolves to the Axios response for the verify payment request.
   */
  static verifyPaymentByGuest(request: any) {
    return client.post("admin/payment/guest-verify", request);
  }
}

export { PaymentService };
